import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { environment } from "src/environments/environment";
import { Router } from '@angular/router';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-application-programme',
  templateUrl: './application-programme.component.html',
  styleUrls: ['./application-programme.component.scss']
})
export class ApplicationProgrammeComponent implements OnInit {

  applicationTypes: applicationTypes[] = []; 
  payload : payload = {
    Surname: "",
    FirstName: "",
    MiddleName: "",
    DOB: new Date(),
    ApplicationType: "",
    ContactPhone: "",
    ContactEmail: "",
  };
  loading = false;
  notification = {};
  validationError: boolean = false;
  showPassword = false;

  constructor(private httpClient: HttpClient, private router: Router, private domSanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.getApplictionTypes()
  }

  getApplictionTypes() {
    this.notification = {};
    this.loading = true;
    const baseUrl = `${environment.BASE_URL}/applications/applicationtypes`;
    this.httpClient
      .get(baseUrl)
      .subscribe({
        next: (res: any) => {
          this.applicationTypes = res?.Data;
          this.loading = false;
        },
        error: (err) => {
          this.loading = false;
          this.notification = {
            error: true,
            message:
              err?.Message ||
              err?.error?.Message ||
              "An error occurred. Try again",
          };
        },
      });
  }
  saveApplication() {
    if (this.validatePayload()) {
      this.validationError = false;

      this.notification = {};
      this.loading = true;
      const baseUrl = `${environment.BASE_URL}/applications/savenewapplication`;
      this.httpClient
        .post(baseUrl, this.payload)
        .subscribe({
          next: (res: any) => {
            if (res.Success) {
              this.downloadFile(res);
            }
            this.loading = false;
            this.notification = {
              error: false,
              message:
                "Application submitted successfully",
            };
            setTimeout(() => {
              this.router.navigateByUrl("/application/login");
            }, 1500);
          },
          error: (err) => {
            this.loading = false;
            this.notification = {
              error: true,
              message:
                err?.Message ||
                err?.error?.Message ||
                "An error occurred. Try again",
            };
          },
        });
    }
    else {
      this.validationError = true;
    }
  }
  validatePayload() : boolean {
    return this.payload.Surname != "" &&
    this.payload.FirstName != "" &&
    this.payload.MiddleName != "" &&
    this.payload.DOB != new Date() &&
    this.payload.ApplicationType != "" &&
    this.payload.ContactPhone != "" &&
    this.payload.ContactEmail != "";
  }

  downloadFile(res: any) {
    var file_path = `data:application/octet-stream;base64,${res.Data.Data}`;
    var downloader = document.createElement('A');
    downloader.setAttribute("href", file_path.toString());
    downloader.setAttribute("download", res.Data.Name);
    document.body.appendChild(downloader);
    downloader.click();
    document.body.removeChild(downloader);
  }

}

interface payload {
  Surname: string;
  FirstName: string;
  MiddleName: string;
  DOB: Date;
  ApplicationType: string;
  ContactPhone: string;
  ContactEmail: string;
}

interface applicationTypes {
  Id: string;
  Name: string;
}
